require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-darkest.css
var $cf8ed174d1fbd864d1206b5e8a3c262$exports = {};
$cf8ed174d1fbd864d1206b5e8a3c262$exports = {
  "spectrum--darkest": "_spectrum--darkest_acf7f"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-global.css
var $b3d87d42a3b0ee7f09fdccf7740f9569$exports = {};
$b3d87d42a3b0ee7f09fdccf7740f9569$exports = {
  "spectrum": "_spectrum_539bd",
  "spectrum--medium": "_spectrum--medium_539bd",
  "spectrum--large": "_spectrum--large_539bd",
  "spectrum--darkest": "_spectrum--darkest_539bd",
  "spectrum--dark": "_spectrum--dark_539bd",
  "spectrum--light": "_spectrum--light_539bd",
  "spectrum--lightest": "_spectrum--lightest_539bd"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-large.css
var $b402298dcb2ea73f1cd9cf191$exports = {};
$b402298dcb2ea73f1cd9cf191$exports = {
  "spectrum--large": "_spectrum--large_d054c"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-lightest.css
var $a065f9015bd96e7bb6ca03721fb$exports = {};
$a065f9015bd96e7bb6ca03721fb$exports = {
  "spectrum--lightest": "_spectrum--lightest_05988"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-medium.css
var $b02b84ece36f72b1103c5ef5d9e1692a$exports = {};
$b02b84ece36f72b1103c5ef5d9e1692a$exports = {
  "spectrum--medium": "_spectrum--medium_0d6a0"
};
var $b3d87d42a3b0ee7f09fdccf7740f9569$$interop$default = $parcel$interopDefault($b3d87d42a3b0ee7f09fdccf7740f9569$exports);
var $a065f9015bd96e7bb6ca03721fb$$interop$default = $parcel$interopDefault($a065f9015bd96e7bb6ca03721fb$exports);
var $cf8ed174d1fbd864d1206b5e8a3c262$$interop$default = $parcel$interopDefault($cf8ed174d1fbd864d1206b5e8a3c262$exports);
var $b02b84ece36f72b1103c5ef5d9e1692a$$interop$default = $parcel$interopDefault($b02b84ece36f72b1103c5ef5d9e1692a$exports);
var $b402298dcb2ea73f1cd9cf191$$interop$default = $parcel$interopDefault($b402298dcb2ea73f1cd9cf191$exports);
let theme = {
  global: $b3d87d42a3b0ee7f09fdccf7740f9569$$interop$default,
  light: $a065f9015bd96e7bb6ca03721fb$$interop$default,
  dark: $cf8ed174d1fbd864d1206b5e8a3c262$$interop$default,
  medium: $b02b84ece36f72b1103c5ef5d9e1692a$$interop$default,
  large: $b402298dcb2ea73f1cd9cf191$$interop$default
};
exports.theme = theme;
